<template lang="html">
    <div v-if="gif" class="scrible-wrapper">
        <img class="img" :style="{width: `${width}%`, margin: margin}" :src="gif.url" alt="" @click="handleAction()">
    </div>
</template>

<script>
    import actionHandler from '@/mixins/actionHandler.mixin'
  export default {
    name: 'SectionScribble',
    mixins: [actionHandler],
    props: {
      gif: {
        type: [Object, Boolean],
        default: false
      },
      alignment: {
        type: [Object, Boolean],
        default: false
      },
      width: {
        type: Number,
        default: 100
      }
    },
    computed: {
      margin () {
        if(this.alignment && this.alignment.value === 'left') {
            return '0 auto 0 0'
        }

        if(this.alignment && this.alignment.value === 'right') {
            return '0 0 0 auto'
        }

        return '0 auto'
      }
    }
  }
</script>

<style lang="scss" scoped>
    .scrible-wrapper {
        margin: $padding;
        /*overflow: hidden;*/
    }
    .img {
        display: block;
    }
</style>
